<template>
	<div class="home-container" :class="{ 'dark-theme': isDark }">

			<el-main class="main-content" style="padding: 0;">
				<router-view />
			</el-main>
		</el-container>
	</div>
</template>

<script>
	import api from '../utils/api'

	export default {
		name: 'Home',
		data() {
			return {
				isDark: false,
				breadcrumbList: []
			}
		},
		computed: {
			activeMenu() {
				return this.$route.path
			},
			menuList() {
				// 从路由配置中获取菜单列表
				const homeRoute = this.$router.options.routes.find(route => route.path === '/home')
				if (homeRoute && homeRoute.children) {
					return homeRoute.children.filter(route => route.meta && route.meta.menu)
				}
				return []
			},
			user() {
				return this.$store.getters.getUser
			}
		},
		watch: {
			$route: {
				handler() {
					this.updateBreadcrumb()
				},
				immediate: true
			}
		},
		mounted() {
			// 从本地存储加载主题设置
			const theme = localStorage.getItem('theme')
			if (theme === 'dark') {
				this.isDark = true
				this.setDarkTheme()
			}

			// 检查是否有token，如果有则获取用户信息
			const token = localStorage.getItem('token')
			if (token && !this.user) {
				this.getUserInfo()
			}
		},
		methods: {
			updateBreadcrumb() {
				this.breadcrumbList = []
				if (this.$route.meta && this.$route.meta.breadcrumb) {
					this.breadcrumbList.push({
						name: this.$route.meta.breadcrumb
					})
				}
			},
			toggleTheme() {
				this.isDark = !this.isDark
				if (this.isDark) {
					this.setDarkTheme()
					localStorage.setItem('theme', 'dark')
				} else {
					this.setLightTheme()
					localStorage.setItem('theme', 'light')
				}
			},
			setDarkTheme() {
				document.documentElement.classList.add('dark-theme')
			},
			setLightTheme() {
				document.documentElement.classList.remove('dark-theme')
			},
			handleUserCommand(command) {
				if (command === 'logout') {
					localStorage.removeItem('token')
					this.$store.dispatch('logout')
					this.$router.push('/login')
				}
			},
			getUserInfo() {
				api.account.getUserInfo()
					.then(res => {
						this.$store.dispatch('login', res.data)
					})
					.catch(() => {
						// 获取用户信息失败，跳转到登录页面
						localStorage.removeItem('token')
						this.$router.push('/login')
					})
			}
		}
	}
</script>

<style scoped>

	.menu-sidebar {
		background-color: var(--bg-color);
		border-right: 1px solid var(--border-color);
		box-shadow: 2px 0 10px rgba(0, 0, 0, 0.05);
		transition: all 0.3s ease;
	}

	/* 菜单样式 */
	.el-menu-vertical-demo {
		border-right: none;
	}

	.el-menu {
		border-radius: 0;
	}

	.el-menu-item {
		height: 50px;
		line-height: 50px;
		margin: 10px 10px 0 10px;
		border-radius: 8px;
		font-size: 14px;
		transition: all 0.3s ease;
	}

	.el-menu-item:hover {
		background-color: rgba(64, 158, 255, 0.1) !important;
	}

	.el-menu-item.is-active {
		background-color: var(--primary-color) !important;
		color: white !important;
	}

	.el-menu-item.is-active i {
		color: white !important;
	}

	.top-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		background-color: var(--bg-color);
		border-bottom: 1px solid var(--border-color);
		padding: 0 24px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
		transition: all 0.3s ease;
	}

	.header-left {
		flex: 1;
	}

	.header-right {
		display: flex;
		align-items: center;
		gap: 16px;
	}

	/* 面包屑样式 */
	.el-breadcrumb {
		font-size: 14px;
	}

	.el-breadcrumb__inner {
		color: var(--text-color-secondary) !important;
		font-weight: 400;
	}

	.el-breadcrumb__inner.is-link {
		color: var(--primary-color) !important;
	}

	/* 主题切换按钮 */
	.theme-toggle {
		transition: all 0.3s ease;
	}

	.theme-toggle:hover {
		color: var(--primary-color);
		transform: scale(1.1);
	}

	/* 用户头像样式 */
	.user-avatar {
		display: flex;
		align-items: center;
		cursor: pointer;
		padding: 8px 12px;
		border-radius: 20px;
		transition: all 0.3s ease;
		background-color: var(--bg-color-light);
	}

	.user-avatar:hover {
		background-color: rgba(64, 158, 255, 0.1);
		transform: translateY(-1px);
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	}

	.user-avatar img {
		width: 32px;
		height: 32px;
		border-radius: 50%;
		margin-right: 8px;
		border: 2px solid var(--primary-color);
	}

	.user-name {
		font-size: 14px;
		font-weight: 500;
		color: var(--text-color);
		transition: all 0.3s ease;
	}

	.main-content {
		overflow-y: auto;
		background-color: var(--bg-color-light);
		transition: all 0.3s ease;
	}

	/* 响应式设计 */
	@media screen and (max-width: 768px) {
		.menu-sidebar {
			width: 180px !important;
		}

		.top-header {
			padding: 0 16px;
		}

	}
</style>